import { logout } from "../api/client/backendclient";

export const actionTypeSelector = (state) => state.actionType;
export const errorSelector = (state) => state.error;
export const loadingGlobalSelector = (state) => state.showLoadingGlobal;

export const authSelector = (state) => state.auth;

export const alertSelector = (state) => state.alert;
export const showAlertSelector = (state) => state.showAlert;

export const personSelector = (state) => state.person;
export const personsSelector = (state) => state.persons;
export const personsModifiedSelector = (state) => state.personsModified;

export const personNumberCheckSelector = (state) => state.personNumberCheckResult;
export const socSecCheckSelector = (state) => state.socSecCheckResult;
export const personNumberSelector = (state) => state.personNumber;
export const importEmployeesSelector = (state) => state.importEmployees;

export const organizationSelector = (state) => state.organization;
export const organizationsSelector = (state) => state.organizations;
export const organizationDocumentsSelector = (state) => state.organizationDocuments;
export const organizationDocumentSelector = (state) => state.organizationDocument;
export const selectedOrganizationSelector = (state) => state.selectedOrganization;
export const activeIntegrationsSelector = (state) => state.activeIntegrations;

export const contractsSelector = (state) => state.contracts ?? [];
export const contractSelector = (state) => state.contract;
export const detailContractSelector = (state) => state.detailContract;
export const contractCountSelector = (state) => state.contractCount;
export const modelContractCountSelector = (state) => state.contractModelCount;
export const contractsModifiedSelector = (state) => state.contractsModified;

export const languageCodesSelector = (state) => state.languageCodes;
export const languagesSelector = (state) => state.languages;
export const languageSelector = (state) => state.language;
export const languagesModifiedSelector = (state) => state.languagesModified;

export const skillsSelector = (state) => state.skills;
export const skillSelector = (state) => state.skill;
export const skillsModifiedSelector = (state) => state.skillsModified;

export const coursesSelector = (state) => state.courses;
export const courseSelector = (state) => state.course;
export const coursesModifiedSelector = (state) => state.coursesModified;

export const educationsSelector = (state) => state.educations;
export const educationSelector = (state) => state.education;
export const educationsModifiedSelector = (state) => state.educationsModified;

export const discussionsSelector = (state) => state.discussions;
export const discussionSelector = (state) => state.discussion;
export const discussionsModifiedSelector = (state) => state.discussionsModified;

export const employmentCertificatesSelector = (state) => state.employmentCertificates;
export const employmentCertificateSelector = (state) => state.employmentCertificate;
export const employmentCertificatesModifiedSelector = (state) => state.employmentCertificatesModified;

export const equipmentsSelector = (state) => state.equipments;
export const equipmentSelector = (state) => state.equipment;
export const equipmentsModifiedSelector = (state) => state.equipmentsModified;

export const notificationsSelector = (state) => state.notifications;
export const unreadNotifCountSelector = (state) => state.unreadNotifCount;

export const codeListsModified = (state) => state.codeListsModified;
export const codeItemsModified = (state) => state.codeItemsModified;

const initialState = {
  person: {
    personId: null,
    nr: null,
    details: {},
    controlDetails: {},
    nationalDetails: {},
    salaryDetails: {},
    otherDetails: {},
  },
  auth: null,
  persons: null,
  error: null,
  alert: null,
  showAlert: false,
  showLoadingGlobal: false,
  personSearch: { list: [], params: "" },
  notifications: [],
  unreadNotifCount: 0,
  selectedOrganization: null, // selected organization data (businessId, etc.)
  activeIntegrations: {}, // activated integrations of currently selected organization businessId
};

const regExLoading = /_LOADING$/;
const regExSucceededDoneFail = /_(?:SUCCEEDED|DONE|FAIL)$/;

export default function PL2State(state = initialState, action) {
  if (import.meta.env.DEV) {
    console.info("action", action);
  }

  let errorState = action.type === "ERROR" ? action.payload : state.error;
  let alertState = action.type === "ALERT" ? action.payload : state.alert;
  let showAlertState = action.type === "ALERT" ? true : state.showAlert;
  let showLoadingGlobalState = { ...state.showLoadingGlobal };

  switch (action.type) {
    case "CLEAR_CONTRACT_DETAILS":
      return { ...state, person: {}, detailContract: null, personNumber: null, contractCount: null };

    //case "GET_PERSON_CONTRACTS_SUCCEEDED":
    //  return {
    //  ...state,
    //  contracts: action.payload.contracts
    //};

    case "GET_PERSON_CONTRACTS_SUCCEEDED":
      return { ...state, contracts: action.payload.contracts };

    case "SET_UNREAD_NOTIFICATIONS_COUNT":
      return { ...state, unreadNotifCount: action.payload };

    case "GET_NOTIFICATIONS_FIRSTPAGE_SUCCEEDED": // clear list
      return { ...state, notifications: [...action.payload] };

    case "GET_NOTIFICATIONS_PAGE_SUCCEEDED": // add to list
      return { ...state, notifications: [...state.notifications, ...action.payload] };

    case "GET_PREFILL_EMPLOYMENT_CERTIFICATE_SUCCEEDED":
      return { ...state, employmentCertificate: action.payload.employmentCertificate };

    case "NOTIFICATION_ADD":
      return {
        ...state,
        notifications: [action.payload, ...state.notifications],
        unreadNotifCount: state.unreadNotifCount + 1,
      };

    case "CLOSE_ALERT":
      showAlertState = false;
      alertState = null;
      break;

    // TODO: these cases are problematic since the payload is used to update AG Grid.
    // These statements reset the person payload and in some rare cases the payload will be empty before
    // AG Grid can update the grid.
    /*
    case "GET_PERSON_CANCELLED":
    case "POST_PERSON_SUCCEEDED":
    case "POST_PERSON_EDIT_SUCCEEDED":
    case "DELETE_PERSON_SUCCEEDED":
    case "CLEAR_PERSON_SEARCHLIST":
      state = {...state, person: {...initialState.person} };
      break;
    */

    case "LOGOUT_SUCCEEDED":
      logout();
      return { ...initialState, auth: null };

    case "LOADING_GLOBAL_SHOW":
    case action.type.match(regExLoading)?.input:
      //showLoadingGlobalState = true;
      break;

    case "LOADING_GLOBAL_HIDE":
    case action.type.match(regExSucceededDoneFail)?.input:
      showLoadingGlobalState = false;
      break;
  }

  const newState = {
    ...state,
    alert: alertState,
    showAlert: showAlertState,
    error: errorState,
    showLoadingGlobal: showLoadingGlobalState,
    actionType: action.type,
    ...action.payload,
  };
  return newState;
}
